import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      confirmDisabled: true
    };
  },
  props: {
    totalRecipientsCount: {
      type: Number,
      default: 0
    },
    newRecipientsCount: {
      type: Number,
      default: 0
    }
  }
};